import { render, staticRenderFns } from "./IntensiveTherapy.vue?vue&type=template&id=7b6080ac&scoped=true"
import script from "./IntensiveTherapy.vue?vue&type=script&lang=js"
export * from "./IntensiveTherapy.vue?vue&type=script&lang=js"
import style0 from "./IntensiveTherapy.vue?vue&type=style&index=0&id=7b6080ac&prod&lang=scss&scoped=true"
import style1 from "./IntensiveTherapy.vue?vue&type=style&index=1&id=7b6080ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6080ac",
  null
  
)

export default component.exports